import { render, staticRenderFns } from "./UserDetailSection.vue?vue&type=template&id=2f937a2a&"
import script from "./UserDetailSection.vue?vue&type=script&lang=js&"
export * from "./UserDetailSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports